<template>
  <section class="page-title-wrap position-relative text-center over-bg" :class="{ active: active }">
    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + winW + ' ' + (winH + 107)" :height="(winH + 107)">
      <defs>
        <linearGradient id="page0_2-a" x1="37.721%" x2="95.923%" y1="0%" y2="100%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="97.714%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page0_2-b" x1="50%" x2="50%" y1="0%" y2="96.708%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page0_2-c" x1="50%" x2="50%" y1="26.741%" y2="100%">
          <stop offset="0%" :stop-color="accent"/>
          <stop offset="100%" :stop-color="accent" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="page0_2-d" x1="50%" x2="50%" y1="26.741%" y2="100%">
          <stop offset="0%" :stop-color="accent"/>
          <stop offset="100%" :stop-color="accent" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="page0_2-e" x1="50%" x2="50%" y1="-7.331%" y2="75.546%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="page0_2-f" x1="50%" x2="50%" y1="69.274%" y2="0%">
          <stop offset="0%" :stop-color="mainColor" stop-opacity="0"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
      </defs>

      <g :transform="'translate(-' + xMod + ')'">
        <polygon
          fill="url(#page0_2-a)"
          :points="xMod + ' ' + (winH - 100) + ' ' + (winW + xMod) + ' ' + (winH - xMod) + ' ' + (winW + xMod) + ' ' + (winH + smallGradBotRightYmod) + ' ' + xMod + ' ' + (winH + smallGradBotLeftYmod)"
          :transform="'matrix(-1 0 0 1 ' + (winW + (xMod * 2)) + ' 0)'"
        />
        <polygon
          fill="url(#page0_2-b)"
          :points="xMod + ' 0 ' + (winW + xMod) + ' 0 ' + (winW + xMod) + ' ' + (winH + bigGradBotRightMod) + ' ' + xMod + ' ' + (winH + bigGradBotLeftMod)"
        />

        <ellipse
          :cx="rightCircCx"
          :cy="rightCircCy"
          fill="url(#page0_2-c)"
          fill-opacity=".7"
          rx="56.5"
          ry="55"
          :transform="'rotate(-30 ' + rightCircCx + ' ' + rightCircCy + ')'"
          ref="rightCirc"
          style="opacity: 0"
        />

        <ellipse
          :cx="leftCircCx"
          :cy="leftCircCy"
          fill="url(#page0_2-d)"
          fill-opacity=".7"
          :rx="leftCircSize"
          :ry="leftCircSize"
          :transform="'rotate(' + leftCircRotate + ' ' + leftCircCx + ' ' + leftCircCy + ')'"
          ref="leftCirc"
          style="opacity: 0"
        />

        <g v-if="isSmall" :data-transform="isSafari ? 'rotate(40 -263.713 253.404)' : 'rotate(40 -363.713 403.404)'"
           :transform="isSafari ? 'rotate(40 -263.713 253.404)' : 'rotate(40 -363.713 403.404)'" style="opacity: 0;"
           ref="box">
          <rect width="74.682" height="228.865" x="19.712" fill="url(#page0_2-e)"/>
          <polygon fill="url(#page0_2-f)" points="0 41.412 19.712 0 19.712 228.865 0 270.277"/>
        </g>
        <g v-else ref="box"
           :data-transform="'rotate(40.1) translate(-182.345665, -684.901435) translate(88.345665, 415.901435)'"
           style="opacity: 0;">
          <rect width="148.394655" height="454.757814" x="39.1686272" y="1.13686838" fill="url(#page0_2-e)"></rect>
          <polygon fill="url(#page0_2-f)"
                   points="-2.27373675 82.2852775 39.1686272 1.13686838 39.1686272 454.757814 -2.27373675 537.043091"></polygon>
        </g>

        <g
          :data-transform="'scale(-1, 1) rotate(45.000000) translate(-1188.735922, -449.698588) translate(1123.235922, 262.198588)'"
          ref="box2" v-if="!isSmall">
          <rect x="27.3099859" y="1.13686838e-13" width="103.466887" height="317.075945" fill="url(#page0_2-e)"></rect>
          <polygon fill="url(#page0_2-f)"
                   points="-2.27373675e-13 57.3726967 27.3099859 1.13686838e-13 27.3099859 317.075945 -2.27373675e-13 374.448642"></polygon>
        </g>

      </g>

    </svg>

    <div class="position-absolute d-flex flex-column align-items-stretch w-75 title-text" :style="txtStyles">
      <header class="d-flex flex-column justify-content-end align-items-center header-wrap">

        <h1
          class="mb-0 heading"
          v-html="head"
          ref="head"
          :style="{ letterSpacing: headSpace + 'em', paddingLeft: headSpace + 'em' }"
        ></h1>
        <span class="subhead" v-html="subhead" ref="sub"></span>

      </header>

      <div class="footer-wrap d-flex flex-column justify-content-center align-items-center">

        <h2
          class="mb-4 keyword"
          v-html="kw"
          ref="kw"
          :style="{ letterSpacing: kwSpace + 'em', paddingLeft: kwSpace + 'em' }"
        ></h2>

        <div class="numeral-wrap position-relative">

          <svg class="orb-vect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 45">
            <defs>
              <linearGradient id="page0_orb" x1="50%" x2="50%" y1="100%" y2="0%"
                              :gradientTransform="'rotate(' + orbDeg + ' 0.5 0.5)'">
                <stop offset="0%" :stop-color="accent"/>
                <stop offset="100%" :stop-color="mainColor"/>
              </linearGradient>

              <linearGradient id="page0_line" x1="5.494%" x2="83.054%" y1="50%" y2="50%">
                <stop offset="0%" :stop-color="mainColor"/>
                <stop offset="97.541%" :stop-color="accent"/>
              </linearGradient>
            </defs>

            <ellipse style="opacity: 0" cx="30.5" cy="23" fill="url(#page0_orb)" rx="21.5" ry="21"
                     transform="rotate(135 30.5 23)" ref="orb"/>
            <rect style="opacity: 0" width="60" height="3" y="21" fill="url(#page0_line)" ref="ring"/>
          </svg>

          <div class="dashes d-flex justify-content-center overflow-hidden position-absolute"
               :style="[ isSmall && isSafari ? { height: '115px' } : { height: '150px' } ]">
            <div class="inner position-absolute h-100" :style="{ borderLeft: '1px dashed ' + mainColor }"></div>
          </div>
        </div>
      </div>
    </div>

  </section>

</template>

<script>
  import { shuffleArr } from '@/lib/funcs'
  import { TimelineMax, Power3 } from 'gsap'
  import TitleMixin from '@/components/report/mixins/TitleMixin'

  export default {
    name: 'Title0',
    mixins: [ TitleMixin ],
    data () {
      return { tl: new TimelineMax(), yMod: 71, xMod: 88, orbDeg: 0 }
    },
    computed: {
      bigGradBotLeftMod () { return this.isSmall ? 24 : -76 },

      bigGradBotRightMod () { return this.isSmall ? 104 : 8 },

      smallGradBotLeftYmod () { return this.isSmall ? 22 : -75 },

      smallGradBotRightYmod () { return this.isSmall ? 105 : 4 },

      rightCircCx () { return this.isSmall ? ((this.winW / 2) - 187.5) + 423.43 : 400 },

      rightCircCy () { return this.isSmall ? this.wrapH * 0.25 : 0 },

      leftCircSize () { return this.isSmall ? 25 : 120 },

      leftCircRotate () { return this.isSmall ? 135 : 0 },

      leftCircCx () { return this.isSmall ? ((this.winW / 2) - 187.5) + 102 : this.winW * 0.05 },

      leftCircCy () { return this.isSmall ? this.wrapH * 0.16 : this.wrapH * 0.4 }
    },
    methods: {
      setTweens () {
        this.tl.set( [ this.headSpans, this.kwSpans, this.$refs.sub ], { opacity: 0 } )
          .set( [ this.$refs.leftCirc, this.$refs.rightCirc ], { yPercent: 35 } )
          .set( this.$refs.leftCirc, { xPercent: -100 } )
          .set( this.$refs.rightCirc, { xPercent: 100 } )
          .set( this.$refs.box, { attr: { transform: `translate(-${this.$refs.box.getBBox().width}, ${this.winH * 0.35}) ${this.$refs.box.getAttribute( 'data-transform' )}` } } )
          .set( this.$refs.ring, { scaleX: 0, opacity: 1 } )
          .set( this.$refs.orb, { scale: 0, transformOrigin: '50% 50%', opacity: 1 } )
          .set( this.$refs.sub, { yPercent: 100 } )

        if ( !this.isSmall ) {
          this.tl.set( this.$refs.box, {
            attr: {
              transform: `translate(${(this.winW * 0.25 - 65) - this.$refs.box.getBBox().width}, ${this.winH * 0.88 + this.$refs.box.getBBox().height * 0.35}) ${this.$refs.box.getAttribute( 'data-transform' )}`
            }
          } )
          this.tl.set( this.$refs.box2, {
            opacity: 0,
            attr: {
              transform: `translate(${this.winW + this.$refs.box2.getBBox().width}, ${449.698588 + 449.698588 * 0.35}) ${this.$refs.box2.getAttribute( 'data-transform' )}`
            }
          } )
        }
      },
      tweenIn () {
        let headSpans = shuffleArr( [ ...this.headSpans ] )
        let kwSpans = shuffleArr( [ ...this.kwSpans ] )
        let staggerEls = [ this.$refs.leftCirc, this.$refs.rightCirc ]

        if ( this.$refs.leftCirc ) {
          this.tl.staggerTo( staggerEls, this.time * 3, {
            opacity: 1,
            xPercent: 0,
            yPercent: 0,
            ease: Power3.easeOut
          }, this.stagger * 3, 'in' )

          if ( this.isSmall ) {
            this.tl.to( this.$refs.box, this.time * 3, {
              delay: this.stagger * 2,
              opacity: 1,
              attr: {
                transform: `translate(0, ${this.winH * 0.35}) ${this.$refs.box.getAttribute( 'data-transform' )}`
              }
            }, 'in' )
          } else {
            this.tl.to( this.$refs.box, this.time * 3, {
              delay: this.stagger * 2,
              opacity: 1,
              ease: Power3.easeOut,
              attr: {
                transform: `translate(${this.winW * 0.25 - 65}, ${this.winH * 0.88}) ${this.$refs.box.getAttribute( 'data-transform' )}`
              }
            }, 'in' )
            this.tl.to( this.$refs.box2, this.time * 3, {
              delay: this.stagger * 3,
              opacity: 1,
              ease: Power3.easeOut,
              attr: {
                transform: `translate(${this.winW}, 449.698588) ${this.$refs.box2.getAttribute( 'data-transform' )}`
              }
            }, 'in' )
          }

          this.tl.to( this, this.time, { headSpace: 0.1 }, 'in' )
            .staggerTo( headSpans, this.time, { opacity: 1 }, this.stagger, 'in' )
            .to( this.$refs.sub, this.time, { opacity: 1, yPercent: 0 }, 'in' )
            .to( this, this.time, { kwSpace: 0.2666 }, 'in+=' + (this.stagger * 2) )
            .staggerTo( kwSpans, this.time, { opacity: 1 }, this.stagger, 'in+=' + (this.stagger * 2) )
            .to( this.$refs.ring, this.time, { scaleX: 1, ease: Power3.easeOut }, 'in+=' + (this.stagger * 2) )
            .to( this.$refs.orb, this.time, { scale: 1, ease: Power3.easeOut }, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
            .call( () => this.$emit( 'tween-done' ), [], this, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
            .to( this, this.time * 10, { orbDeg: 360 }, 'in+=' + (this.stagger * 2) )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .page-title-wrap {
    @include screen-xs-sm {
      .header-wrap {
        flex : 1 0 60%;
      }
    }
    @include screen-md-lg-xl {
      .footer-wrap {
        height : 50vh;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/titleVects/Title0.vue